import BadgeCount from '@/shared/Badges/BadgeCount'
import css from './parameterTab.module.css'
import Button from '@/shared/Buttons/Button'
import { useMemo, useState } from 'react'
import UploadIcon from '@/assets/icons/upload.svg?react'
import DownloadIcon from '@/assets/icons/download.svg?react'
import SearchInput from '@/shared/Inputs/SearchInput'
import ParameterGroupsTree from '../components/ParameterGroupsTree'
import ParameterTable from '../components/ParameterTable'
import { IParameter, IParameterGroup } from '../parameters.types'
import ParameterDataTypeDropdown from '../components/ParameterDataTypeDropdown'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import ResizableByDrag from '@/shared/Common/ResizableByDrag'
import useTreeSelectCtrl from '@/shared/Tree/ctrl/useTreeSelectCtrl'
import ParametersCUDService from '@/pages/Parameters/services/ParametersCUDService'
import useParameters from '@/pages/Parameters/hooks/useParameters.ts'
import parametersCUDServiceEvents from '@/pages/Parameters/services/ParametersCUDService/parametersCUDService.events.ts'
import ProtectedContent from '@/services/rights/ProtectedContent'

const ParameterTab = () => {
  const [filterDataType, setFilterDataType] = useState<IParameter['dataType']>(null)
  const [search, setSearch] = useState('')

  const parameters = useParameters()
  const treeSelectCtrl = useTreeSelectCtrl<IParameterGroup['id']>('parameter-groups-tree', null)

  const items = useMemo(() => {
    let resultItems = parameters

    if (treeSelectCtrl.selectedItem) {
      resultItems = resultItems.filter((p) => p.groupId === treeSelectCtrl.selectedItem)
    }

    if (search) {
      const lowerSearch = search.toLowerCase()
      resultItems = resultItems.filter(
        (p) => p.name.toLowerCase().includes(lowerSearch) || p.sourceId.toLowerCase().includes(lowerSearch)
      )
    }

    if (filterDataType) {
      resultItems = resultItems.filter((p) => p.dataType === filterDataType)
    }

    return resultItems
  }, [treeSelectCtrl.selectedItem, parameters, search, filterDataType])

  return (
    <div className="flex-lines gap24 height100">
      <ParametersCUDService />
      <div className="flex-space-between">
        <div className="inline-flex-gap gap24">
          <div className="inline-flex-gap gap8 center">
            <h2 className="text-heading-4">Переменные</h2>
            <BadgeCount type="default" count={parameters.length} />
          </div>
          <ProtectedContent requiredRight="parameters:create">
            <CreateEntityButton
              text="Создать переменную"
              onClick={() => parametersCUDServiceEvents.requestParameterCreate()}
            />
          </ProtectedContent>
        </div>

        <div className="inline-flex-gap gap8">
          <Button size="default" text="Импорт" type="default" icon={<UploadIcon />} disabled={true} />
          <Button size="default" text="Экспорт" type="default" icon={<DownloadIcon />} disabled={true} />
        </div>
      </div>
      <div className={css.wrapperSearch}>
        <div className={css.searchInput}>
          <SearchInput
            name="search"
            onChange={setSearch}
            value={search}
            placeHolder="Поиск по переменным"
            inputStyle={{ height: '32px' }}
          />
        </div>
        <ParameterDataTypeDropdown
          name="dataType"
          value={filterDataType}
          onChange={setFilterDataType}
          title="Тип данных"
          wrapperStyle={{ height: '32px', width: '135px' }}
        />
      </div>
      <div className="inline-flex-gap gap24 height100">
        <ResizableByDrag initialWidth={280} resizerClassname={css.resizer} wrapperClassname={css.resizerWrapper}>
          <ParameterGroupsTree treeSelectCtrl={treeSelectCtrl} />
        </ResizableByDrag>
        <ParameterTable items={items} />
      </div>
    </div>
  )
}

export default ParameterTab
